/**
 * Single source for API base URL. Same as login and all other API calls.
 * - Production build: REACT_APP_API_URL from .env.production (https://config-go.com).
 * - Local dev (npm start): http://localhost:8000 when no REACT_APP_API_URL is set.
 * - Deployed on config-go.com: same origin when REACT_APP_API_URL is unset (Nginx proxies /api).
 */
function getApiUrl() {
  const envUrl = process.env.REACT_APP_API_URL;
  if (typeof envUrl === 'string' && envUrl.trim() !== '') {
    return envUrl.trim().replace(/\/$/, '');
  }

  if (typeof window === 'undefined' || !window.location) {
    return '';
  }

  const hostname = window.location.hostname || '';
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000';
  }

  return window.location.origin;
}

export const API_URL = getApiUrl();
